import {apiFetch, checkStatus, objectToFormData, objectToQueryParameters} from "./commons";
import { isArrayWithLength} from "../../helpers/commons";

function findUsers(filter) {

	var query = objectToQueryParameters(filter);
	return apiFetch('/users/all'+query, {
	    accept: "application/json"
	 })
	.then(checkStatus)
}

function pageUsers(filter) {

	var query = objectToQueryParameters(filter);
	return apiFetch('/users'+query, {
	    accept: "application/json"
	 })
	.then(checkStatus)
}

function lookupUser(id) {

	return apiFetch('/users/'+id, {
	    accept: "application/json"
	 })
	.then(checkStatus)
}

function createUser(data) {

	var form = objectToFormData(data, ["roles", "permissions", "schools"]);

	if (data && isArrayWithLength(data.roles)) {
		data.roles.forEach((item) => {
			form.append("roles[]", item);
		});
	}

	if (data && isArrayWithLength(data.permissions)) {
		data.permissions.forEach((item) => {
			form.append("permissions[]", item);
		});
	}

	if (data && isArrayWithLength(data.schools)) {
		data.schools.forEach((item) => {
			let school = {};
			school.id = item.id;
			school.name = item.name;
			form.append("schools[]", JSON.stringify(school));
		});

	}

	return apiFetch('/users', {
		method: 'post',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}

function updateUser(id, data) {

	var form = objectToFormData(data, ["roles", "permissions", "schools"]);

	if (data && isArrayWithLength(data.roles)) {
		data.roles.forEach((item) => {
			form.append("roles[]", item);
		});
	}

	if (data && isArrayWithLength(data.permissions)) {
		data.permissions.forEach((item) => {
			form.append("permissions[]", item);
		});
	}

	if (data && isArrayWithLength(data.schools)) {
		data.schools.forEach((item) => {
			let school = {};
			school.id = item.id;
			school.name = item.name;
			form.append("schools[]", JSON.stringify(school));
		});
	}

	return apiFetch('/users/'+id, {
		method: 'PATCH',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}

function updateUserPassword(id, data) {
		
	var form = objectToFormData(data);
	
	return apiFetch('/users/'+id+'/pwd', {
		method: 'PATCH',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}

function updateSelfPassword(data) {
	
	var form = objectToFormData(data);
	
	return apiFetch('/users/self/pwd', {
		method: 'PATCH',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}

function updateUserThirdPartyData(id, data) {
	
	var form = objectToFormData(data);
	
	return apiFetch('/users/'+id+'/third-party', {
		method: 'PATCH',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}

/** POST /users/:id/block — comando dedicado de bloqueio administrativo.
 *  Body opcional { reason }. Backend seta blockedAt=now(), invalida cache,
 *  loga BLOCK. Idempotente. */
function blockUser(id, reason) {
	return apiFetch('/users/'+id+'/block', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', accept: 'application/json' },
		body: JSON.stringify({ reason: reason || null })
	}).then(checkStatus);
}

/** POST /users/:id/unblock — desbloqueio administrativo. Idempotente. */
function unblockUser(id) {
	return apiFetch('/users/'+id+'/unblock', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', accept: 'application/json' },
		body: JSON.stringify({})
	}).then(checkStatus);
}

/** POST /users/:id/resend-invite — reenvia convite: se ainda válido, mesmo
 *  link (mantém expiresAt); se expirado, novo token + expiresAt. */
function resendInvite(id) {
	return apiFetch('/users/'+id+'/resend-invite', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', accept: 'application/json' },
		body: JSON.stringify({})
	}).then(checkStatus);
}

/** DELETE /users/:id — soft-delete (Ebean @SoftDelete). Backend preserva a linha
 *  e usa revive path do createUser quando o mesmo email é recriado. */
function deleteUser(id) {
	var form = new FormData();
	return apiFetch('/users/'+id, {
		method: 'DELETE',
		accept: 'application/json',
		body: form
	}).then(checkStatus);
}

function importUsers(data) {
	
	var path = '/users/import';
	
	var form = objectToFormData(data, ["data"]);
	
	if (data && isArrayWithLength(data.data)) {
		data.data.forEach((item, index) => {
			if (item) {
				form.append("data[]", JSON.stringify(item));
			}
		});
	}
	
	return apiFetch(path, {
		method: 'post',
	    accept: "application/json",
	    body: form
	 })
	.then(checkStatus)
}


const userApi = { pageUsers, findUsers, lookupUser, createUser, updateUser, updateUserPassword,
				 updateSelfPassword, updateUserThirdPartyData, importUsers,
				 blockUser, unblockUser, resendInvite, deleteUser, };

export default userApi;